import React, { useEffect, useState } from 'react';
import Wrapper from './styles';
import { useFilterContext } from '../../context/filter_context';
import { getUniqueValues, formatPrice } from '../../utils/helpers';
import { FaCircle } from 'react-icons/fa';

import { useProductsContext } from '../../context/products_context';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import { Button } from '@chakra-ui/react';
import useDebounce from '../../hooks/useDebounce';


const Filters = ({
  filters,
  selectedFilters,
  setSelectedFilters,
  subCategories,
  setCurrentPage,
  setLoading,
  min,
  max,
  setMinimumValue,
  setMaximumValue
}) => {
  const { products, products_loading } = useProductsContext();
  const {
    filters: {
      text,
      company,
      category,
      color,
      min_price,
      max_price,
      price,
      sleeves,
      collar,
      offers,
    },
    updateFilters,
    clearFilters,
    all_products,
  } = useFilterContext();
  const [minValue, setMinValue] = useState(min);
  const [maxValue, setMaxValue] = useState(max);
  const [openFilters, setOpenFilters] = useState({});
  const debouncedMaxValue = useDebounce(maxValue, 250);
  
  useEffect(() => {
    handleMaxChange(debouncedMaxValue)
  }, [debouncedMaxValue])

  const toggleFilter = (filterType) => {
    setOpenFilters((prev) => ({
      ...prev,
      [filterType]: !prev[filterType],
    }));
  };

  const handleSubmit = () => {
    setSelectedFilters([]);
    setCurrentPage(1)
    setMinimumValue(10)
    setMaximumValue(100000)
  };

  const handleSelectFilter = (e, opt, name) => {
    setLoading(true);
    setCurrentPage(1)
    let updatedName = name === 'Metal Type' ? 'metalType' : 'category';
    setSelectedFilters((prev) => {
      
      const updated = [...prev];

      const existingIndex = updated.findIndex((f) => f.type === name);

      if (existingIndex === -1) {
        updated.push({
          type: name,
          [opt]: true,
          options: [opt],
        });
      } else {
        if (
          updated[existingIndex].options.includes(opt) &&
          updated[existingIndex].type === name
        ) {
          let updatedOptions = updated[existingIndex].options.filter(
            (e) => e !== opt
          );
          updated[existingIndex] = {
            type: updated[existingIndex].type,
            [opt]: false,
            options: updatedOptions,
          };
        } else {
          updated[existingIndex] = {
            type: updated[existingIndex].type,
            [opt]: true,
            options: [...updated[existingIndex].options, opt],
          };
        }
      }

      return updated;
    });
  };
  const handleMinChange = (value) => {
    if (value <= maxValue && value>=10) {
      setCurrentPage(1)
      setMinValue(value);
      setMinimumValue(value)
      setMaximumValue(maxValue)
    }
  };

  const handleMaxChange = (value) => {
    if (value >= minValue) {
      setCurrentPage(1);
      setMaxValue(value);
      setMinimumValue(minValue)
      setMaximumValue(value)
    }
  };
  return (
    <div className='w-full border border-gray-300 rounded-lg p-4'>
      {filters?.map((filter) => {
        const isOpen = openFilters[filter.name] ?? true;

        return (
          <div key={filter.name} className='mb-4 border-b pb-2'>
            <p
              className='flex justify-between items-center font-semibold text-gray-800 mb-2 cursor-pointer select-none'
              onClick={() => toggleFilter(filter.name)}
            >
              <span>{filter.name}</span>
              <span className='text-xl text-gray-600'>
                {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
              </span>
            </p>

            {isOpen && (
              <div className='pl-2 transition-all duration-300 ease-in-out font-poppins'>
                {filter.options.map((opt) => {
                  let filterName =
                    filter.name === 'Category' ? 'categoryName' : filter.name === 'Type' ? '_for' : 'name';
                  let isSelected =
                    selectedFilters?.length > 0 &&
                    selectedFilters
                      ?.find((e) => e?.type === filter?.name)
                      ?.options.includes(opt[filterName]);
                  return (
                    <div
                      key={opt}
                      className='flex items-center mb-1 font-poppins'
                      onClick={(e) =>
                        handleSelectFilter(e, opt[filterName], filter.name)
                      }
                    >
                      <input
                        type='checkbox'
                        id={opt}
                        className='mr-2 accent-[#B1832E]'
                        checked={
                          selectedFilters?.length > 0 &&
                          selectedFilters
                            ?.find((e) => e?.type === filter?.name)
                            ?.options.includes(opt[filterName])
                        }
                      />
                      <label
                        htmlFor={`${filter.name}-${filterName}`}
                        className={`text-sm capitalize font-sans ${
                          isSelected ? 'text-[#B1832E]' : 'text-gray-700'
                        }`}
                      >
                        {opt[filterName]}
                      </label>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
      <div className='flex flex-col gap-3 w-full max-w-sm'>
        <p className='font-semibold text-gray-800'>Price</p>
        <div className='relative w-full h-4'>
          <div className='absolute top-1/2 -translate-y-1/2 w-full h-1 bg-gray-300 rounded'></div>

          <div
            className='absolute top-1/2 -translate-y-1/2 h-1 rounded z-10'
            style={{
              left: `${(minValue / max) * 100}%`,
              width: `${((maxValue - minValue) / max) * 100}%`,
            }}
          ></div>

          <input
            type='range'
            min={1}
            max={100000}
            value={minValue}
            onChange={(e) => handleMinChange(Number(e.target.value))}
            className='absolute w-full top-0 z-20'
          />

          <input
            type='range'
            min={1}
            max={100000}
            value={maxValue}
            onChange={(e) => setMaxValue(Number(e.target.value))}
            className='absolute w-full top-0 z-30 pointer-events-auto'
          />
        </div>
        <div className='flex flex-col xl:flex-row gap-3 mr-4 items-center mb-3'>
          <p className='border flex gap-4 p-2 rounded-md'>
            <span>
              <input
                type='number'
                value={min}
                onChange={(e) => handleMinChange(Number(e.target.value))}
                className='text-red-600 outline-none w-20'
                placeholder='Min'
              />
            </span>
          </p>
          <p>to</p>

          <p className='border flex gap-4 p-2 rounded-md'>
            <span>
              <input
                type='number'
                value={max}
                onChange={(e) => handleMaxChange(Number(e.target.value))}
                className='text-red-600 outline-none w-20'
                placeholder='Max'
              />
            </span>
          </p>
        </div>
      </div>
      <button
        onClick={handleSubmit}
        className='hover:bg-[#063a86] bg-[#D3A143] rounded-md p-2 text-white mt-2'
      >
        Clear filters
      </button>
    </div>
  );
};

export default Filters;
